"use client";
import React from "react";
import ShopVertical from "./ShopVertical";
import usePagination from "hooks/usePagination";
import ShopService from "services/shop";
import { get } from "utils/lodash";

interface Props {
  title?: string;
  description?: string;
}

const ShopVerticalSection: React.FC<Props> = ({
  title = "Địa điểm khác",
  description = "Khám phá các địa điểm khác trên nền tảng Lookme",
}) => {
  const pagination = usePagination({
    initialParams: {
      page: 1,
      limit: 16,
    },
    loader: async (params) => {
      const res = await ShopService.find({
        ...params,
        where: {},
      });
      return {
        data: get(res, "data", []),
        total: get(res, "params.total", 0),
      };
    },
  });

  React.useEffect(() => {
    pagination?.onReload?.();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ShopVertical
      pagination={pagination}
      title={title}
      description={description}
    />
  );
};

export default ShopVerticalSection;
